var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "feed-item single-img",
      attrs: { "data-spm-type": "resource" },
    },
    [
      _c(
        "a",
        {
          staticClass: "feed-item__box",
          attrs: {
            href: _vm.feedData.url,
            target: "_blank",
            "data-mphref": _vm.feedData.personalPage,
          },
        },
        [
          _c("h5", { staticClass: "feed-item__title" }, [
            _vm._v(_vm._s(_vm.feedData.title)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "img-box img-do feed-item__left" }, [
            _c("img", {
              staticClass: "feed-item__cover",
              attrs: {
                "data-src": _vm.feedData.images[0],
                src: "//statics.itc.cn/web/static/images/pic/preload.png",
                alt: "配图",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feed-item__right" }, [
            _c("p", { staticClass: "feed-item__des" }, [
              _vm._v(_vm._s(_vm.feedData.brief)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feed-item__footer" }, [
              _c(
                "a",
                {
                  staticClass: "auther-box",
                  attrs: { href: _vm.feedData.personalPage },
                },
                [
                  _c("img", {
                    staticClass: "auther-img",
                    attrs: { src: _vm.feedData.authorPic, alt: "作者头像" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "auther__name" }, [
                    _c("span"),
                    _vm._v(_vm._s(_vm.feedData.authorName)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.feedData.fixTime)),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }